export default __webpack_public_path__ + "static/media/XI_Old_Black.2edf00cb.png";